import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { IconArrowForward } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "../styles/NavigationDrilldownIndentedList.styles";
import { useTracking } from "../hooks/useTracking/useTracking";
export var NavigationDrilldownIndentedList = function NavigationDrilldownIndentedList(_ref) {
  var _page$items;
  var disabled = _ref.disabled,
    page = _ref.page;
  var tracking = useTracking();
  return /*#__PURE__*/React.createElement(_StyledUl, {
    $_css: [styles.list, styles.level2list]
  }, (_page$items = page.items) === null || _page$items === void 0 ? void 0 : _page$items.map(function (item) {
    var _item$items, _item$items2;
    return /*#__PURE__*/React.createElement(_StyledLi, {
      key: item.title,
      $_css2: styles.level2listItem
    }, (_item$items = item.items) !== null && _item$items !== void 0 && _item$items.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledStrong, {
      $_css3: styles.level2Title
    }, item.title), /*#__PURE__*/React.createElement(_StyledUl2, {
      "data-testid": "indented-level3",
      $_css4: styles.list
    }, (_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : _item$items2.map(function (subItem) {
      return /*#__PURE__*/React.createElement("li", {
        key: subItem.title
      }, /*#__PURE__*/React.createElement(_StyledA, {
        href: subItem.url,
        onClick: function onClick(evt) {
          return tracking.onClickLink(evt, subItem);
        },
        tabIndex: disabled ? -1 : 0,
        $_css5: styles.level3link
      }, subItem.title));
    }))) : /*#__PURE__*/React.createElement(_StyledA2, {
      href: item.url,
      onClick: function onClick(evt) {
        return tracking.onClickLink(evt, item);
      },
      tabIndex: disabled ? -1 : 0,
      $_css6: styles.level2Link
    }, /*#__PURE__*/React.createElement("span", null, item.title), /*#__PURE__*/React.createElement(_StyledIconArrowForward, {
      height: 16,
      width: 16,
      $_css7: styles.forwardArrow
    })));
  }));
};
var _StyledUl = _styled("ul")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledLi = _styled2("li")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledStrong = _styled3("strong")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledUl2 = _styled4("ul")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledA = _styled5("a")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledA2 = _styled6("a")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledIconArrowForward = /*#__PURE__*/_styled7(IconArrowForward).withConfig({
  displayName: "NavigationDrilldownIndentedList___StyledIconArrowForward",
  componentId: "sc-1a14oau-0"
})(["", ""], function (p) {
  return p.$_css7;
});